import { connect } from 'react-redux';
import { getInvoiceDetail } from 'store/invoice/actions';
import FinanceDetail from './FinanceDetail';

const mapStateToProps = (state) => ({
  invoiceDetail: state.invoice.invoiceDetail,
  invoiceDetailLoading: state.invoice.invoiceDetailLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoiceDetail: (payload) => dispatch(getInvoiceDetail(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinanceDetail);
